import { render, staticRenderFns } from "./OfficialVouchers.html?vue&type=template&id=552a60cc&scoped=true&external"
import script from "./OfficialVouchers.js?vue&type=script&lang=js&external"
export * from "./OfficialVouchers.js?vue&type=script&lang=js&external"
import style0 from "./OfficialVouchers.vue?vue&type=style&index=0&id=552a60cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552a60cc",
  null
  
)

export default component.exports